import "./style.css";

const strory1 = "https://lh3.googleusercontent.com/d/1zKDIlMdugm5skxLePBOgwVffxVuU2UKE=w800";
const strory2 = "https://lh3.googleusercontent.com/d/1WXcxjlbRzWqLQeFvPAkuZnP16qAzRZjO=w800";
const strory4 = "https://lh3.googleusercontent.com/d/1ibFAGGHAXVXckgMGDuiSVyNb2YG-hDgE=w800";
const strory3 = "https://lh3.googleusercontent.com/d/1NOaVl1UgLUcID93F8sIdssvth8DSqc9i=w800";
const strory5 = "https://lh3.googleusercontent.com/d/13AIzHX2KJJURR_2BzpkwoMkgqLx9-Dfy=w800";

const Story = () => {
  return (
    <div id="story" className="story-area section-padding">
      <div className="container">
        <div className="col-l2">
          <div className="section-title text-center">
            <h2>Câu chuyện của chúng mình</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="story clearfix">
              <div className="story-top"></div>
              <div className="content-wrapper">
                <div className="item">
                  <div className="story-icon">
                    <span className="flaticon-birds-in-love"></span>
                  </div>
                  <div className="story-content">
                    <div className="image-wrap">
                      <div className="single-image">
                        <div>
                          <img src={strory1} alt="" />
                        </div>
                      </div>
                    </div>
                    <h2>Lần đầu gặp gỡ</h2>
                    <span className="date">25.06.2024</span>
                    <p>
                      Tại FSOFT - nơi tình yêu bắt đầu.
                      <br/>
                      <br/>
                      <em>*Đố các bạn tìm được tụi mình hehe* </em>
                    
                    </p>
                  </div>
                </div>
                <div className="item">
                  <div className="story-icon">
                    <span className="flaticon-birds-in-love"></span>
                  </div>
                  <div className="story-content">
                    <div className="image-wrap">
                      <div className="single-image">
                        <div>
                          <img src="https://lh3.googleusercontent.com/d/1iqEnerKO1Hkwfjws6O3kYSPfa9QgdVOo=w800" alt="" />
                        </div>
                      </div>
                    </div>
                    <h2>Tỏ tình</h2>
                    <span className="date">12.12.2024</span>
                    <p>
                      Tối hôm đó:<br/>
                      - Tỏ tình chưa mà nắm tay?<br/>
                      - <em>*hít 1 hơi thật sâu, lấy đà hết 5 phút*</em> Thật ra thì abcxyz... nên nếu chị cho em cơ hội thì em sẽ cố gắng hết sức<br/>
                      - <em>*nghĩ nghĩ*</em> Ủa cơ hội gì? Cố gắng gì?<br/>
                      - <em>*nghĩ nghĩ*</em> Hê hê sao mà biết được<br/><br/>
                      Thì đó... sao mà biết được đó là cơ hội bên cạnh yêu thương, chăm sóc và rước chị về nhà đâu hehe bị lừa 💕
                    </p>
                  </div>
                </div>
                <div className="item">
                  <div className="story-icon">
                    <span className="flaticon-birds-in-love"></span>
                  </div>
                  <div className="story-content">
                    <div className="image-wrap">
                      <div className="single-image">
                        <div>
                          <img src={strory4} alt="" />
                        </div>
                      </div>
                    </div>
                    <h2> Dạm ngõ & Cầu hôn</h2>
                    <span className="date">26.06.2025</span>
                    <p>
                      26.06.2025 không chỉ là ngày vô cùng đặc biệt với chúng mình mà còn là ngày siêu đặc biệt với Hanh nữa.
                      Vì đó vừa là ngày dạm ngõ, vừa là ngày Hanh cầu hôn mình và cũng là ngày sinh nhật của Hanh luôn ^^.
                      Hôm đó, Hanh đã dắt mình đi hết 10 vòng Vinhome . . . <em>*thả hint thế thôi, đoạn sau mọi người tự điền vào chỗ trống nhá*</em>
                    </p>
                  </div>
                </div>
                <div className="item">
                  <div className="story-icon">
                    <span className="flaticon-birds-in-love"></span>
                  </div>
                  <div className="story-content">
                    <div className="image-wrap">
                      <div className="single-image">
                        <div>
                          <img src="https://lh3.googleusercontent.com/d/1Nn-QI97Pc97icMZvrpZGze_j_ycBDCMz=w800" alt="" />
                        </div>
                      </div>
                    </div>
                    <h2>Đăng ký kết hôn </h2>
                    <span className="date">10.11.2025</span>
                    <p>
                         Rồi xong chốt sổ !!! <br/>  Ngày cho cơ hội đâu nghĩ nhanh vậy đâu 🥲<br/>
                         Đó là mình thôi, <br/>còn Hanh. . . Hanh ngồi cười hẹ hẹ<br/>
                         <em>*tại vì mọi chuyện đã trong dự tính rồi*</em>                           
                      {/* Sau rất nhiều lần tự hỏi "chắc chưa?", hai đứa nhìn nhau
                      và cùng gật đầu "chắc rồi!". Chúng mình đã chính thức ký
                      vào tấm giấy hồng. Đó là khoảnh khắc đầy hạnh phúc và hồi
                      hộp khi cả hai cùng cam kết đồng hành bên nhau trên con
                      đường phía trước. */}
                    </p>
                  </div>
                </div>
                <div className="item">
                  <div className="story-icon">
                    <span className="flaticon-birds-in-love"></span>
                  </div>
                  <div className="story-content">
                    <div className="image-wrap">
                      <div className="single-image">
                        <div>
                          <img src={strory5} alt="" />
                        </div>
                      </div>
                    </div>
                    <h2>Chuẩn bị cho ngày cưới</h2>
                    <span className="date">12.12.2025</span>
                    <p>
                        Lúc này tụi mình đang đi duyệt hình cưới nè. 
                        Mặc dù vợ mình hơi vô tri nhưng cảm ơn bạn đã đọc đến đây. <br/>Các công đoạn chuẩn bị cho ngày cưới
                        cũng khá nhiều và không phải mọi thứ đều hoàn hảo nhưng chúng mình vẫn cố gắng tươm tất nhất có thể để chào đón mọi người ^v^
                        
                      {/* Nhân dịp kỷ niệm ngày yêu nhau, chúng mình đã cùng nhau đi
                      lựa và chỉnh sửa ảnh cưới. Đó là một ngày đầy niềm vui khi
                      cả hai cùng ngồi lại, xem từng bức ảnh và chọn ra những
                      khoảnh khắc đẹp nhất để lưu giữ. Mỗi bức ảnh đều gợi nhớ về
                      những kỷ niệm ngọt ngào trong hành trình yêu thương của
                      chúng mình. */}
                    </p>
                  </div>
                </div>
                <div className="item">
                  <div className="story-icon">
                    <span className="flaticon-birds-in-love"></span>
                  </div>
                  <div className="story-content">
                    <div className="image-wrap">
                      <div className="single-image">
                        <div>
                          <img src="https://lh3.googleusercontent.com/d/1eF9GN4B0vhv1S_p3CvVcTtQX1q4obJ-r=w800" alt="" />
                        </div>
                      </div>
                    </div>
                    <h2>Lễ Đính Hôn</h2>
                    <span className="date">24.01.2026</span>
                    <p>
                      Ngày mà cô dâu chính thức về nhà chồng! Cảm xúc vừa vui vừa xúc động, vừa hạnh phúc vừa bồi hồi. Cảm ơn mọi người đã đến chung vui cùng gia đình chúng mình 💕
                    </p>
                  </div>
                </div>
                <div className="item">
                  <div className="story-icon">
                    <span className="flaticon-birds-in-love"></span>
                  </div>
                  <div className="story-content">
                    <div className="image-wrap">
                      <div className="single-image">
                        <div>
                          <img src="https://lh3.googleusercontent.com/d/1fdy7ecSGqfZdwaPmtZQzIpwdAFFKqb75=w800" alt="" />
                        </div>
                      </div>
                    </div>
                    <h2>Lễ Vu Quy</h2>
                    <span className="date">24.01.2026</span>
                    <p>
                      Cùng ngày hôm đó, lễ vu quy được tổ chức trang trọng. Cô dâu chính thức về nhà chồng trong sự chúc phúc của hai bên gia đình và bạn bè. Một ngày thật đáng nhớ! 🎊
                    </p>
                  </div>
                </div>
                <div className="item">
                  <div className="story-icon">
                    <span className="flaticon-birds-in-love"></span>
                  </div>
                  <div className="story-content">
                    <div className="image-wrap">
                      <div className="single-image">
                        <div>
                          <img src="https://lh3.googleusercontent.com/d/16VM30OxNhVyf5r1OmA99bvtEyDF5wSNj=w800" alt="Lễ Thành Hôn" />
                        </div>
                      </div>
                    </div>
                    <h2>Lễ Thành Hôn — Về Chung Một Nhà</h2>
                    <span className="date">26.02.2026</span>
                    <p>
                      Khoảnh khắc thiêng liêng nhất khi hai đứa chính thức trao nhau chiếc nhẫn cưới, trở thành bạn đời đồng hành cùng nhau trên mọi nẻo đường cuộc sống.
                      Một cái kết viên mãn cho hành trình hẹn hò và là khởi đầu cho mái ấm ngập tràn yêu thương! 💕
                    </p>
                  </div>
                </div>
                <div className="item special-item">
                  <div className="story-icon">
                    <span className="flaticon-birds-in-love"></span>
                  </div>
                  <div className="story-content">
                    <div className="image-wrap">
                    </div>
                    <h2>Nhắn nhủ & Tri ân</h2>
                    <p>
                         Hành trình yêu thương của chúng mình sẽ trọn vẹn hơn khi nhận được những lời chúc phúc từ tất cả mọi người.<br/> Hãy để lại đôi dòng yêu thương trong cuốn sổ lưu bút cho chúng mình nhé ~
                    </p>
                  </div>
                </div>
              </div>
              <div className="story-bottom"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Story;
